import React from 'react';
import Hero from '../components/Hero';
import FastagShowcase from '../components/FastagShowcase';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import AgentForm from '../components/AgentForm';
import CustomerForm from '../components/CustomerForm';

const Home = () => {
  return (
    <>
      <Hero />
      <FastagShowcase />
      <Services />
      <WhyChooseUs />
      <AgentForm />
      <CustomerForm />
    </>
  );
};

export default Home;
